import { defaultFilter } from '@components/Table/table.utils';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EntityTypeConfigKeys } from '@utils/entityViewConfig';
import { PAGE_PATHS } from '../../../../../../types';

const path = PAGE_PATHS.INCIDENTS;
export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/incidents/{-$id}/')({
  staticData: {
    path,
    key: EntityTypeConfigKeys.IncidentThreats,
  },
  validateSearch: zodValidator(withDefaults(schema.INCIDENTS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
});
